module.exports = __webpack_public_path__ + "img/assessmenttaskdefault.5f7a27e9.svg";